var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomentumStrongNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.79 28.442c0-.766.589-1.415 1.415-1.415h6.959L21.843 16.765l-6.546 6.546c-.531.59-1.416.59-1.947 0l-9.908-9.908c-.59-.53-.59-1.415 0-2.005.531-.53 1.416-.53 2.006 0l8.905 8.906 6.546-6.547c.531-.53 1.416-.53 2.006 0l11.264 11.324v-7.019c0-.766.59-1.415 1.416-1.415.766 0 1.415.649 1.415 1.415v10.38c0 .826-.649 1.416-1.415 1.416h-10.38c-.826 0-1.416-.59-1.416-1.416z"
  })));
}
export default SvgMomentumStrongNegative;